import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/store/swine';
import { axios } from '@/utils/axios';
import { Endpoints } from '@/utils/endpoints';
import { DashboardDetails, GetDashboardParams } from '@/models/swine/dashboard.model';

@Module({
  namespaced: true,
  dynamic: true,
  name: 'dashboard.details',
  store,
})
class DashboardDetailsStore extends VuexModule {
  response: DashboardDetails | null = null;
  isLoading = false;
  error: any | null = null;
  params: GetDashboardParams | null = null;

  @Mutation
  updateLoadingStatus(payload: boolean) {
    this.isLoading = payload;
  }

  @Mutation
  setError(error: any) {
    this.error = error;
  }

  @Mutation
  setResponse(payload: DashboardDetails | null) {
    this.response = payload;
  }

  @Mutation
  setParams(payload: GetDashboardParams | null) {
    this.params = payload;
  }

  @Action
  getDashboardDetails(params: GetDashboardParams) {
    this.context.commit('updateLoadingStatus', true);
    this.context.commit('setError', null);
    this.context.commit('setResponse', null);
    try {
      this.context.commit('setParams', params);
      axios
        .get<DashboardDetails>(`${Endpoints.Dashboard}/swine`, {
          params: params,
        })
        .then((response) => {
          this.context.commit('setResponse', response.data);
        });
    } catch (error) {
      this.context.commit('setError', error);
    }
    this.context.commit('updateLoadingStatus', false);
  }

  @Action
  resetStore() {
    this.context.commit('setError', null);
    this.context.commit('setResponse', null);
    this.context.commit('setParams', null);
  }
}
export default getModule(DashboardDetailsStore);
